import React from 'react';
import './badges.css';

const BadgeBasic = (props) => {
  const { content, icon, className } = props;
  
  return (
    <div className={`container-badge-basic ${className}`}>
      <p className='badge-basic'>
        {content}
      </p>
      {icon}
    </div>
  );
}

export default BadgeBasic;